// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2lGUc","sendOtp":"AuthorizeToLogin_sendOtp__1vFr9"};